import { HStack, ReclassifyIcon, MergeIcon } from '@cdl/heartbeat-react';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CustomButton } from '../../../ecg/components/CustomButton';
import { Cluster } from '../../clustering.types';
import { selectedBaseClustersSelector } from '../../selectors/cluster.selectors';
import { mergeClusters } from '../../thunks/merge-clusters.thunk';
import { reverseMerge } from '../../thunks/reverse-merge-clusters.thunk';
import { CONTAINER_WIDTH } from './Morphology';

interface Props {
  morphology: Cluster;
}

export const MorphologyActionBar: React.FC<Props> = ({ morphology }) => {
  const dispatch = useDispatch();
  const selectedClusters = useSelector(selectedBaseClustersSelector);
  const merge = useCallback(async () => {
    await dispatch(mergeClusters(selectedClusters, morphology));
  }, [dispatch, selectedClusters, morphology]);

  const unMerge = useCallback(async () => {
    await dispatch(reverseMerge(morphology));
  }, [dispatch, morphology]);

  return (
    <HStack width={CONTAINER_WIDTH} justifyContent='space-between' mt='s'>
      <CustomButton
        dataTestId='un-merge-btn'
        variant='secondary'
        onClick={unMerge}
        rightIcon={<ReclassifyIcon />}
      >
        Remove last cluster
      </CustomButton>
      {selectedClusters.length !== 0 &&
        selectedClusters.every(
          (cluster) => morphology.classification === cluster.classification,
        ) && (
          <CustomButton
            dataTestId='merge-btn'
            onClick={merge}
            rightIcon={<MergeIcon />}
          >
            Merge
          </CustomButton>
        )}
    </HStack>
  );
};
